import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };
  const navItems = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'about',
    label: 'Over mij'
  }, {
    id: 'services',
    label: 'Diensten'
  }, {
    id: 'qualifications',
    label: 'Kwalificaties'
  }, {
    id: 'experience',
    label: 'Ervaring'
  }, {
    id: 'availability',
    label: 'Tarieven'
  }, {
    id: 'contact-new',
    label: 'Contact'
  }];
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-black border-t border-zinc-800" data-id="element-243">
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-95 z-40 flex flex-col items-center justify-center" data-id="element-244">
          <button onClick={closeMenu} className="absolute top-6 right-6 p-2 text-zinc-400 hover:text-white" aria-label="Close menu" data-id="element-245">
            <XIcon className="w-6 h-6" data-id="element-246" />
          </button>
          <nav className="flex flex-col items-center gap-5" data-id="element-247">
            {navItems.map(item => <a key={item.id} href={`#${item.id}`} onClick={closeMenu} className="text-white hover:text-slate-300 transition-colors py-3 px-5 text-lg" data-id="element-248">
                {item.label}
              </a>)}
          </nav>
        </div>}
      {/* Bottom bar */}
      <div className="flex items-center justify-between px-5 py-3 bg-black" data-id="element-249">
        <div data-id="element-250">
          <span className="font-light text-base text-slate-300" data-id="element-251">
            Saense Beveiliging
          </span>
        </div>
        <div className="flex items-center gap-3" data-id="element-252">
          <a href="#contact-new" className="px-4 py-2 bg-slate-800 hover:bg-slate-900 text-white text-sm font-normal rounded-none transition-colors" data-id="element-253">
            Contact
          </a>
          <button onClick={toggleMenu} className="p-2 text-zinc-400 hover:text-white bg-zinc-900 rounded-none" aria-label="Menu" data-id="element-254">
            <MenuIcon className="w-5 h-5" data-id="element-255" />
          </button>
        </div>
      </div>
    </div>;
}